<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                Neue Kategorie
            </template>
        </navbar>

        <div class="sticky-top text-right">
            <b-button @click="storeCategory"
                      class="btn-round"
                      variant="success">{{$t('saveTitle')}}
            </b-button>
        </div>


        <b-card title="Image">
            <b-form-group label="select image"
                          :state="!validation.hasError('image')"
                          :invalid-feedback="validation.errorTitle('image')"
                          class="required"></b-form-group>

            <template v-if="previewUrl !== null">
                <b-img :src="previewUrl" width="120" alt="placeholder"></b-img>
            </template>
            <b-form-file
                    @change="onSelectFile"
                    v-model="form.image" class="mt-3" plain></b-form-file>
        </b-card>
        <!--Image-->

        <b-card title="information">
            <b-form-group
                    class="required"
                    label="Kategoriename"
                    :state="!validation.hasError('title')"
                    :invalid-feedback="validation.errorTitle('title')"
            >
                <b-input
                        v-model="form.title"></b-input>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="seo url"
                    :state="!validation.hasError('title_seo')"
                    :invalid-feedback="validation.errorTitle('title_seo')"
            >
                <b-input
                        placeholder="lordofhanf.com/shop/"
                        v-model="form.title_seo"></b-input>
            </b-form-group>
        </b-card>
        <!--information-->

        <b-card title="Kategorie page">
            <b-form-group
                    class="required"
                    label="header title"
                    :state="!validation.hasError('subtitle')"
                    :invalid-feedback="validation.errorTitle('subtitle')"
            >
                <b-input
                        v-model="form.subtitle"></b-input>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="description"
                    :state="!validation.hasError('header')"
                    :invalid-feedback="validation.errorTitle('header')"
            >
                <tinymce id="d1" :other_options="optionsEditor" v-model="form.header"></tinymce>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="description bottom page desktop"
                    :state="!validation.hasError('description')"
                    :invalid-feedback="validation.errorTitle('description')"
            >
                <tinymce id="d2" :other_options="optionsEditor" v-model="form.description"></tinymce>
            </b-form-group>
            <b-form-group
                    class="required"
                    label="description bottom page mobile"
                    :state="!validation.hasError('descriptionMobile')"
                    :invalid-feedback="validation.errorTitle('descriptionMobile')"
            >
                <tinymce id="d3" :other_options="optionsEditor" v-model="form.descriptionMobile"></tinymce>
            </b-form-group>
        </b-card>
        <!--END Description-->

        <b-card title="Google SEO">
            <b-form-group
                    label="meta description"
                    :state="!validation.hasError('seocontent')"
                    :invalid-feedback="validation.errorTitle('seocontent')"
            >
                <tinymce id="d10" :other_options="optionsEditor" v-model="form.seocontent"></tinymce>
            </b-form-group>
            <b-form-group
                    label="meta title"
            >
                <b-input v-model="form.meta_title"></b-input>
            </b-form-group>
        </b-card>

        <b-card title="Options">
            <b-form-checkbox
                    id="checkbox-1"
                    name="checkbox-1"
                    v-model="form.is_hidden"
            >
                Kategorie nicht anzeigen?
            </b-form-checkbox>
            <b-form-checkbox
                    id="checkbox-2"
                    name="checkbox-2"
                    v-model="form.is_offer"
            >
                Kategorie is Angebot?
            </b-form-checkbox>
            <b-form-checkbox
                    id="checkbox-3"
                    name="checkbox-3"
                    v-model="form.is_category_mix"
            >
                is Kombinierter Versand?
            </b-form-checkbox>
            <b-form-checkbox
                    id="checkbox-4"
                    name="checkbox-4"
                    v-model="form.is_category_new"
            >
                is neu?
            </b-form-checkbox>

            <b-form-group
                    description="default: 50 €"
                    label="Transport Price">
                <b-input v-model="form.transport_price"></b-input>
            </b-form-group>
            <b-form-group
                    label="Transport Title">
                <b-input v-model="form.transport_title"></b-input>
            </b-form-group>

        </b-card>

        <b-button @click="storeCategory" variant="success">{{$t('saveTitle')}}</b-button>

    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import Validation from '../../Services/Validation/Validation'

    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                myTrue:true,
                previewUrl: null,
                validation: new Validation(),
                optionsEditor: {
                    height: 300,
                    toolbar: [
                        'formatselect | fontsizeselect | fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat | bootstrap4grid'
                    ]
                },
                form: {
                    title: '',
                    meta_title: null,
                    title_seo: '',
                    header: '',
                    subtitle: '',
                    order: 0,
                    description: '',
                    descriptionMobile: '',
                    seocontent: '',
                    is_hidden: false,
                    is_offer: false,
                    image: null,
                    is_hidden_amount: false,
                    is_category_mix: false,
                    is_category_new: false,
                    amount_title: null,
                    transport_price: null,
                    transport_title: null,
                },
                errors: null
            }
        },
        methods: {
            onSelectFile(event) {
                this.previewUrl = URL.createObjectURL(event.target.files[0]);
            },
            storeCategory() {
                let fd = new FormData();
                fd.append('title', this.form.title);
                fd.append('meta_title', this.form.meta_title);
                fd.append('title_seo', this.form.title_seo);
                fd.append('header', this.form.header);
                fd.append('subtitle', this.form.subtitle);
                fd.append('order', this.form.order);
                fd.append('description', this.form.description);
                fd.append('descriptionMobile', this.form.descriptionMobile);
                fd.append('seocontent', this.form.seocontent);
                fd.append('is_hidden', this.form.is_hidden);
                fd.append('is_offer', this.form.is_offer);
                fd.append('is_hidden_amount', this.form.is_hidden_amount);
                fd.append('is_category_mix', this.form.is_category_mix);
                fd.append('is_category_new', this.form.is_category_new);
                fd.append('amount_title', this.form.amount_title);
                fd.append('transport_price', this.form.transport_price);
                fd.append('transport_title', this.form.transport_title);
                fd.append('image', this.form.image);

                this.$Progress.start();

                Http.post(Http.apiurlV2() + 'category/store', fd)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.created()) {

                            Notification.success(response.data.message);
                            this.$router.push({name: 'Shop'});
                        } else {
                            Notification.error(response.data.message);
                            this.errors = response.data.data;
                            this.validation.store(response.data.data);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            }
        }
    }
</script>

<style scoped>

</style>